import { Directive, computed, input } from '@angular/core';

export type SpinnerSize = 'sm' | 'md' | 'lg';
export type SpinnerTone = 'default' | 'inverse';

/**
 * `.groove-spinner` — element tier.
 *
 * Reduced-motion-as-default: rotation animation lives inside
 * `@media (prefers-reduced-motion: no-preference)`, NOT the default.
 *
 * Default `size` and `tone` values are omitted from the DOM to keep
 * attributes clean (omit-default-attribute pattern).
 */
@Directive({
  selector: '[grooveSpinner]',
  standalone: true,
  host: {
    class: 'groove-spinner',
    role: 'status',
    '[attr.data-size]': 'sizeAttr()',
    '[attr.data-tone]': 'toneAttr()',
    '[attr.aria-label]': 'ariaLabel()',
  },
})
export class GrooveSpinnerDirective {
  readonly size = input<SpinnerSize>('md');
  readonly tone = input<SpinnerTone>('default');
  readonly ariaLabel = input<string>('Loading', { alias: 'aria-label' });

  // Omit default attrs to keep DOM clean.
  protected readonly sizeAttr = computed(() =>
    this.size() === 'md' ? null : this.size(),
  );
  protected readonly toneAttr = computed(() =>
    this.tone() === 'default' ? null : this.tone(),
  );
}
